export const xfdfString = `<?xml version="1.0" encoding="UTF-8" ?>
<xfdf
  xmlns="http://ns.adobe.com/xfdf/" xml:space="preserve">
  <pdf-info
    xmlns="http://www.pdftron.com/pdfinfo" version="2" import-version="4">
    <ffield type="Tx" name="Client Legal Name" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Date" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Address" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="State" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Neighborhood" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Plan Name" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="City" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Zip" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Lot" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Phase" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Base Price" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Lot Premium" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Incentives" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Upgrades" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Purchase Price" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Contingent Home Location" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Btn" name="chkFinancingContingency" />
    <ffield type="Btn" name="chkSaleContingency" />
    <ffield type="Tx" name="Closing Attorney" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Btn" name="chkLoanTypeCash" />
    <ffield type="Btn" name="chkLoanTypeConvential" />
    <ffield type="Btn" name="chkLoanTypeFHA" />
    <ffield type="Btn" name="chkLoanTypeVA" />
    <ffield type="Btn" name="chkLoanTypeOther" />
    <ffield type="Btn" name="chkLoanTypeUSDA" />
    <ffield type="Btn" name="Checkbox" />
    <ffield type="Btn" name="chkAdditionalIncentive" />
    <ffield type="Btn" name="chkAddendumC" />
    <ffield type="Tx" name="SellingCompany" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Btn" name="chkAddendumI" />
    <ffield type="Btn" name="chkAddendumF" />
    <ffield type="Btn" name="chkAddendumE" />
    <ffield type="Btn" name="chkAddendumK" />
    <ffield type="Btn" name="chkAddendumA" />
    <ffield type="Btn" name="chkApprovedLender" />
    <ffield type="Tx" name="ListingAgentName" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Btn" name="chkAddendumG" />
    <ffield type="Btn" name="chkAddendumJ" />
    <ffield type="Tx" name="SellingAgentName" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Btn" name="chkAddendumD" />
    <ffield type="Btn" name="chkAddendumH" />
    <ffield type="Btn" name="chkAddendumB" />
    <ffield type="Btn" name="chkSewer" />
    <ffield type="Btn" name="chkSeptic" />
    <ffield type="Tx" name="Additional Disclosure 1" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Approved Lender Credit" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Purchaser1Name" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Client Email Address" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Client Phone" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Client Address" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Client City State Zip" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Purchaser2Name" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Purchaser2 Address" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Purchaser2 City State Zip" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Purchaser2 Phone" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <ffield type="Tx" name="Purchaser2 Email Address" flags="Multiline">
      <font name="Helvetica" />
    </ffield>
    <widget field="Client Legal Name" name="fe801831e198d958-849d54cce56d7c33" flags="NoPrint" page="1">
      <rect x1="51.73" x2="385.48" y1="641.91" y2="656.91" />
      <apref gennum="0" objnum="491" x="51.73" y="656.91" />
    </widget>
    <widget field="Date" name="fe801834e198d95b-849d54c9e56d7c30" flags="NoPrint" page="1">
      <rect x1="366" x2="406.5" y1="667.59" y2="679.59" />
      <apref gennum="0" objnum="494" x="366" y="679.59" />
    </widget>
    <widget field="Address" name="fe801836e198d95d-849d54c7e56d7c2e" flags="NoPrint" page="1">
      <rect x1="120.75" x2="302.25" y1="587.79" y2="602.79" />
      <apref gennum="0" objnum="496" x="120.75" y="602.79" />
    </widget>
    <widget field="State" name="fe801838e198d95f-849d54c5e56d7c2c" flags="NoPrint" page="1">
      <rect x1="121.49" x2="261.74" y1="572.42" y2="587.42" />
      <apref gennum="0" objnum="498" x="121.49" y="587.42" />
    </widget>
    <widget field="Neighborhood" name="fe80183ae198d961-849d54c3e56d7c2a" flags="NoPrint" page="1">
      <rect x1="121.49" x2="261.74" y1="558.8" y2="573.8" />
      <apref gennum="0" objnum="500" x="121.49" y="573.8" />
    </widget>
    <widget field="Plan Name" name="fe80183ce198d963-849d54c1e56d7c28" flags="NoPrint" page="1">
      <rect x1="139.85" x2="280.1" y1="546.64" y2="561.64" />
      <apref gennum="0" objnum="502" x="139.85" y="561.64" />
    </widget>
    <widget field="City" name="fe80183ee198d965-849d54bfe56d7c26" flags="NoPrint" page="1">
      <rect x1="321.43" x2="445.93" y1="588.55" y2="602.8" />
      <apref gennum="0" objnum="504" x="321.43" y="602.8" />
    </widget>
    <widget field="Zip" name="fe801840e198d967-849d54bde56d7c24" flags="NoPrint" page="1">
      <rect x1="321.75" x2="461.25" y1="574.66" y2="588.91" />
      <apref gennum="0" objnum="506" x="321.75" y="588.91" />
    </widget>
    <widget field="Lot" name="fe801842e198d969-849d54bbe56d7c22" flags="NoPrint" page="1">
      <rect x1="321.05" x2="459.8" y1="560.93" y2="575.18" />
      <apref gennum="0" objnum="508" x="321.05" y="575.18" />
    </widget>
    <widget field="Phase" name="fe801844e198d96b-849d54b9e56d7c20" flags="NoPrint" page="1">
      <rect x1="327.78" x2="459.78" y1="547.92" y2="562.17" />
      <apref gennum="0" objnum="510" x="327.78" y="562.17" />
    </widget>
    <widget field="Base Price" name="fe801846e198d96d-849d54b7e56d7c1e" flags="NoPrint" page="1">
      <rect x1="191.98" x2="333.73" y1="499.45" y2="514.45" />
      <apref gennum="0" objnum="512" x="191.98" y="514.45" />
    </widget>
    <widget field="Lot Premium" name="fe801848e198d96f-849d54b5e56d7c1c" flags="NoPrint" page="1">
      <rect x1="191.99" x2="332.24" y1="485.07" y2="500.07" />
      <apref gennum="0" objnum="514" x="191.99" y="500.07" />
    </widget>
    <widget field="Incentives" name="fe80184ae198d971-849d54b3e56d7c1a" flags="NoPrint" page="1">
      <rect x1="191.99" x2="332.24" y1="457.42" y2="472.42" />
      <apref gennum="0" objnum="516" x="191.99" y="472.42" />
    </widget>
    <widget field="Upgrades" name="fe80184ce198d973-849d54b1e56d7c18" flags="NoPrint" page="1">
      <rect x1="191.98" x2="332.23" y1="472.43" y2="487.43" />
      <apref gennum="0" objnum="518" x="191.98" y="487.43" />
    </widget>
    <widget field="Purchase Price" name="fe80184ee198d975-849d54afe56d7c16" flags="NoPrint" page="1">
      <rect x1="191.99" x2="332.24" y1="443.6" y2="458.6" />
      <apref gennum="0" objnum="520" x="191.99" y="458.6" />
    </widget>
    <widget field="Contingent Home Location" name="fe801850e198d977-849d54ade56d7c14" flags="NoPrint" page="1">
      <rect x1="209.98" x2="542.23" y1="291.01" y2="306.01" />
      <apref gennum="0" objnum="522" x="209.98" y="306.01" />
    </widget>
    <widget appearance="Off" field="chkFinancingContingency" name="fe801852e198d979-849d54abe56d7c12" flags="NoPrint" page="1">
      <rect x1="61.48" x2="74.98" y1="303.83" y2="317.33" />
      <apref appearance-state="Off" gennum="0" objnum="524" x="61.48" y="317.33" />
      <apref appearance-state="Yes" gennum="0" objnum="524" x="61.48" y="317.33" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkSaleContingency" name="fe801857e198d97e-849d54a6e56d7c0d" flags="NoPrint" page="1">
      <rect x1="62.23" x2="74.98" y1="291.12" y2="303.87" />
      <apref appearance-state="Off" gennum="0" objnum="529" x="62.23" y="303.87" />
      <apref appearance-state="Yes" gennum="0" objnum="529" x="62.23" y="303.87" />
      <captions Normal="4" />
    </widget>
    <widget field="Closing Attorney" name="fe80185ce198d983-849d54a1e56d7c08" flags="NoPrint" page="1">
      <rect x1="131.98" x2="376.48" y1="199.21" y2="214.21" />
      <apref gennum="0" objnum="534" x="131.98" y="214.21000000000004" />
    </widget>
    <widget appearance="Off" field="chkLoanTypeCash" name="fe80185ee198d985-849d549fe56d7c06" flags="NoPrint" page="1">
      <rect x1="346.55" x2="359.3" y1="499.81" y2="512.56" />
      <apref appearance-state="Off" gennum="0" objnum="536" x="346.55" y="512.56" />
      <apref appearance-state="Yes" gennum="0" objnum="536" x="346.55" y="512.56" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkLoanTypeConvential" name="fe801863e198d98a-849d549ae56d7c01" flags="NoPrint" page="1">
      <rect x1="346.54" x2="359.29" y1="486.28" y2="499.03" />
      <apref appearance-state="Off" gennum="0" objnum="541" x="346.54" y="499.03" />
      <apref appearance-state="Yes" gennum="0" objnum="541" x="346.54" y="499.03" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkLoanTypeFHA" name="fe801868e198d98f-849d5495e56d7bfc" flags="NoPrint" page="1">
      <rect x1="346.57" x2="359.32" y1="472.05" y2="484.8" />
      <apref appearance-state="Off" gennum="0" objnum="546" x="346.57" y="484.8" />
      <apref appearance-state="Yes" gennum="0" objnum="546" x="346.57" y="484.8" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkLoanTypeVA" name="fe80186de198d994-849d5490e56d7bf7" flags="NoPrint" page="1">
      <rect x1="347.29" x2="360.04" y1="456.69" y2="469.44" />
      <apref appearance-state="Off" gennum="0" objnum="551" x="347.29" y="469.44" />
      <apref appearance-state="Yes" gennum="0" objnum="551" x="347.29" y="469.44" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkLoanTypeOther" name="fe801872e198d999-849d548be56d7bf2" flags="NoPrint" page="1">
      <rect x1="346.92" x2="358.92" y1="431.61" y2="443.61" />
      <apref appearance-state="Off" gennum="0" objnum="556" x="346.92" y="443.61" />
      <apref appearance-state="Yes" gennum="0" objnum="556" x="346.92" y="443.61" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkLoanTypeUSDA" name="fe801877e198d99e-849d5486e56d7bed" flags="NoPrint" page="1">
      <rect x1="346.93" x2="358.93" y1="443.61" y2="455.61" />
      <apref appearance-state="Off" gennum="0" objnum="561" x="346.93" y="455.61" />
      <apref appearance-state="Yes" gennum="0" objnum="561" x="346.93" y="455.61" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="Checkbox" name="fe801886e198d9ad-849d5477e56d7bde" flags="NoPrint" page="1">
      <rect x1="209.95" x2="224.95" y1="169.79" y2="184.79" />
      <apref appearance-state="Off" gennum="0" objnum="576" x="209.95" y="184.78999999999996" />
      <apref appearance-state="Yes" gennum="0" objnum="576" x="209.95" y="184.78999999999996" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" index="1" field="Checkbox" name="fe801882e198d9a9-849d547be56d7be2" flags="NoPrint" page="1">
      <rect x1="61.47" x2="76.47" y1="262.85" y2="277.85" />
      <apref appearance-state="Off" gennum="0" objnum="572" x="61.47" y="277.85" />
      <apref appearance-state="Yes" gennum="0" objnum="572" x="61.47" y="277.85" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkAdditionalIncentive" name="fe801887e198d9ae-849d5476e56d7bdd" flags="NoPrint" page="2">
      <rect x1="59.59" x2="73.09" y1="516.4" y2="529.9" />
      <apref appearance-state="Off" gennum="0" objnum="577" x="59.59" y="529.9" />
      <apref appearance-state="Yes" gennum="0" objnum="577" x="59.59" y="529.9" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkAddendumC" name="fe80188ce198d9b3-849d5471e56d7bd8" flags="NoPrint" page="2">
      <rect x1="72.34" x2="85.09" y1="143.52" y2="156.27" />
      <apref appearance-state="Off" gennum="0" objnum="582" x="72.34" y="156.26999999999998" />
      <apref appearance-state="Yes" gennum="0" objnum="582" x="72.34" y="156.26999999999998" />
      <captions Normal="4" />
    </widget>
    <widget field="SellingCompany" name="fe801891e198d9b8-849d546ce56d7bd3" flags="NoPrint" page="2">
      <rect x1="171.74" x2="307.49" y1="298.44" y2="313.44" />
      <apref gennum="0" objnum="587" x="171.74" y="313.44" />
    </widget>
    <widget appearance="Off" field="chkAddendumI" name="fe801893e198d9ba-849d546ae56d7bd1" flags="NoPrint" page="2">
      <rect x1="302.61" x2="315.36" y1="143.52" y2="156.27" />
      <apref appearance-state="Off" gennum="0" objnum="589" x="302.61" y="156.26999999999998" />
      <apref appearance-state="Yes" gennum="0" objnum="589" x="302.61" y="156.26999999999998" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkAddendumF" name="fe801898e198d9bf-849d5465e56d7bcc" flags="NoPrint" page="2">
      <rect x1="72.34" x2="86.59" y1="95.93" y2="110.18" />
      <apref appearance-state="Off" gennum="0" objnum="594" x="72.34" y="110.18000000000006" />
      <apref appearance-state="Yes" gennum="0" objnum="594" x="72.34" y="110.18000000000006" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkAddendumE" name="fe80189de198d9c4-849d5460e56d7bc7" flags="NoPrint" page="2">
      <rect x1="72.34" x2="86.59" y1="111.63" y2="125.88" />
      <apref appearance-state="Off" gennum="0" objnum="599" x="72.34" y="125.88" />
      <apref appearance-state="Yes" gennum="0" objnum="599" x="72.34" y="125.88" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkAddendumK" name="fe8018a2e198d9c9-849d545be56d7bc2" flags="NoPrint" page="2">
      <rect x1="302.23" x2="315.73" y1="111.64" y2="125.14" />
      <apref appearance-state="Off" gennum="0" objnum="604" x="302.23" y="125.13999999999999" />
      <apref appearance-state="Yes" gennum="0" objnum="604" x="302.23" y="125.13999999999999" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkAddendumA" name="fe8018a7e198d9ce-849d5456e56d7bbd" flags="NoPrint" page="2">
      <rect x1="73.09" x2="85.84" y1="174.32" y2="187.07" />
      <apref appearance-state="Off" gennum="0" objnum="609" x="73.09" y="187.06999999999994" />
      <apref appearance-state="Yes" gennum="0" objnum="609" x="73.09" y="187.06999999999994" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkApprovedLender" name="fe8018ace198d9d3-849d5451e56d7bb8" flags="NoPrint" page="2">
      <rect x1="59.59" x2="72.34" y1="588.79" y2="601.54" />
      <apref appearance-state="Off" gennum="0" objnum="614" x="59.59" y="601.54" />
      <apref appearance-state="Yes" gennum="0" objnum="614" x="59.59" y="601.54" />
      <captions Normal="4" />
    </widget>
    <widget field="ListingAgentName" name="fe8018dee198da05-849d541fe56d7b86" flags="NoPrint" page="2">
      <rect x1="407.27" x2="561.02" y1="359.21" y2="374.21" />
      <apref gennum="0" objnum="664" x="407.27" y="374.21" />
    </widget>
    <widget appearance="Off" field="chkAddendumG" name="fe8018b3e198d9da-849d544ae56d7bb1" flags="NoPrint" page="2">
      <rect x1="302.23" x2="315.73" y1="173.57" y2="187.07" />
      <apref appearance-state="Off" gennum="0" objnum="621" x="302.23" y="187.06999999999994" />
      <apref appearance-state="Yes" gennum="0" objnum="621" x="302.23" y="187.06999999999994" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkAddendumJ" name="fe8018b8e198d9df-849d5445e56d7bac" flags="NoPrint" page="2">
      <rect x1="302.23" x2="314.98" y1="127.8" y2="140.55" />
      <apref appearance-state="Off" gennum="0" objnum="626" x="302.23" y="140.54999999999995" />
      <apref appearance-state="Yes" gennum="0" objnum="626" x="302.23" y="140.54999999999995" />
      <captions Normal="4" />
    </widget>
    <widget field="SellingAgentName" name="fe8018e1e198da08-849d541ce56d7b83" flags="NoPrint" page="2">
      <rect x1="402.8" x2="556.55" y1="298.45" y2="313.45" />
      <apref gennum="0" objnum="667" x="402.8" y="313.45" />
    </widget>
    <widget appearance="Off" field="chkAddendumD" name="fe8018bfe198d9e6-849d543ee56d7ba5" flags="NoPrint" page="2">
      <rect x1="72.34" x2="85.84" y1="127.82" y2="141.32" />
      <apref appearance-state="Off" gennum="0" objnum="633" x="72.34" y="141.31999999999994" />
      <apref appearance-state="Yes" gennum="0" objnum="633" x="72.34" y="141.31999999999994" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkAddendumH" name="fe8018c4e198d9eb-849d5439e56d7ba0" flags="NoPrint" page="2">
      <rect x1="302.23" x2="315.73" y1="158.91" y2="172.41" />
      <apref appearance-state="Off" gennum="0" objnum="638" x="302.23" y="172.40999999999997" />
      <apref appearance-state="Yes" gennum="0" objnum="638" x="302.23" y="172.40999999999997" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkAddendumB" name="fe8018c9e198d9f0-849d5434e56d7b9b" flags="NoPrint" page="2">
      <rect x1="72.34" x2="85.84" y1="158.91" y2="172.41" />
      <apref appearance-state="Off" gennum="0" objnum="643" x="72.34" y="172.40999999999997" />
      <apref appearance-state="Yes" gennum="0" objnum="643" x="72.34" y="172.40999999999997" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkSewer" name="fe8018cee198d9f5-849d542fe56d7b96" flags="NoPrint" page="2">
      <rect x1="187.48" x2="199.48" y1="654.62" y2="666.62" />
      <apref appearance-state="Off" gennum="0" objnum="648" x="187.48" y="666.62" />
      <apref appearance-state="Yes" gennum="0" objnum="648" x="187.48" y="666.62" />
      <captions Normal="4" />
    </widget>
    <widget appearance="Off" field="chkSeptic" name="fe8018d3e198d9fa-849d542ae56d7b91" flags="NoPrint" page="2">
      <rect x1="252.73" x2="265.48" y1="653.87" y2="666.62" />
      <apref appearance-state="Off" gennum="0" objnum="653" x="252.73" y="666.62" />
      <apref appearance-state="Yes" gennum="0" objnum="653" x="252.73" y="666.62" />
      <captions Normal="4" />
    </widget>
    <widget field="Additional Disclosure 1" name="fe8018d8e198d9ff-849d5425e56d7b8c" flags="NoPrint" page="2">
      <rect x1="101.25" x2="511.5" y1="639.62" y2="654.62" />
      <apref gennum="0" objnum="658" x="101.25" y="654.62" />
    </widget>
    <widget field="Approved Lender Credit" name="fe8018dae198da01-849d5423e56d7b8a" flags="NoPrint" page="2">
      <rect x1="469.49" x2="507.74" y1="543.78" y2="558.78" />
      <apref gennum="0" objnum="660" x="469.49" y="558.78" />
    </widget>
    <widget index="1" field="ListingAgentName" name="fe8018dde198da04-849d5420e56d7b87" flags="NoPrint" page="16">
      <rect x1="144.74" x2="280.49" y1="301.68" y2="316.68" />
      <apref gennum="0" objnum="663" x="144.74" y="316.68" />
    </widget>
    <widget index="1" field="SellingAgentName" name="fe8018e0e198da07-849d541de56d7b84" flags="NoPrint" page="16">
      <rect x1="144.74" x2="280.49" y1="197.43" y2="212.43" />
      <apref gennum="0" objnum="666" x="144.74" y="212.43000000000006" />
    </widget>
    <widget field="Purchaser1Name" name="fe8018e2e198da09-849d541be56d7b82" flags="NoPrint" page="16">
      <rect x1="412.49" x2="554.24" y1="518.43" y2="533.43" />
      <apref gennum="0" objnum="668" x="412.49" y="533.43" />
    </widget>
    <widget field="Client Email Address" name="fe8018e4e198da0b-849d5419e56d7b80" flags="NoPrint" page="16">
      <rect x1="379.49" x2="521.24" y1="378.93" y2="393.93" />
      <apref gennum="0" objnum="670" x="379.49" y="393.93" />
    </widget>
    <widget field="Client Phone" name="fe8018e6e198da0d-849d5417e56d7b7e" flags="NoPrint" page="16">
      <rect x1="379.49" x2="521.24" y1="404.43" y2="419.43" />
      <apref gennum="0" objnum="672" x="379.49" y="419.43" />
    </widget>
    <widget field="Client Address" name="fe8018e8e198da0f-849d5415e56d7b7c" flags="NoPrint" page="16">
      <rect x1="390.74" x2="532.49" y1="449.43" y2="464.43" />
      <apref gennum="0" objnum="674" x="390.74" y="464.43" />
    </widget>
    <widget field="Client City State Zip" name="fe8018eae198da11-849d5413e56d7b7a" flags="NoPrint" page="16">
      <rect x1="357.74" x2="499.49" y1="427.68" y2="442.68" />
      <apref gennum="0" objnum="676" x="357.74" y="442.68" />
    </widget>
    <widget field="Purchaser2Name" name="fe8018ece198da13-849d5411e56d7b78" flags="NoPrint" page="16">
      <rect x1="412.51" x2="554.26" y1="301.67" y2="316.67" />
      <apref gennum="0" objnum="678" x="412.51" y="316.67" />
    </widget>
    <widget field="Purchaser2 Address" name="fe8018eee198da15-849d540fe56d7b76" flags="NoPrint" page="16">
      <rect x1="390.74" x2="532.49" y1="230.43" y2="245.43" />
      <apref gennum="0" objnum="680" x="390.74" y="245.43000000000006" />
    </widget>
    <widget field="Purchaser2 City State Zip" name="fe8018f0e198da17-849d540de56d7b74" flags="NoPrint" page="16">
      <rect x1="357.75" x2="499.5" y1="212.41" y2="227.41" />
      <apref gennum="0" objnum="682" x="357.75" y="227.40999999999997" />
    </widget>
    <widget field="Purchaser2 Phone" name="fe8018f2e198da19-849d540be56d7b72" flags="NoPrint" page="16">
      <rect x1="390.74" x2="532.49" y1="182.42" y2="197.42" />
      <apref gennum="0" objnum="684" x="390.74" y="197.41999999999996" />
    </widget>
    <widget field="Purchaser2 Email Address" name="fe8018f4e198da1b-849d5409e56d7b70" flags="NoPrint" page="16">
      <rect x1="390.74" x2="532.49" y1="166.28" y2="181.28" />
      <apref gennum="0" objnum="686" x="390.74" y="181.27999999999997" />
    </widget>
  </pdf-info>
  <fields>
    <field name="Client Legal Name">
      <value></value>
    </field>
    <field name="Date">
      <value></value>
    </field>
    <field name="Address">
      <value></value>
    </field>
    <field name="State">
      <value></value>
    </field>
    <field name="Neighborhood">
      <value></value>
    </field>
    <field name="Plan Name">
      <value></value>
    </field>
    <field name="City">
      <value></value>
    </field>
    <field name="Zip">
      <value></value>
    </field>
    <field name="Lot">
      <value></value>
    </field>
    <field name="Phase">
      <value></value>
    </field>
    <field name="Base Price">
      <value></value>
    </field>
    <field name="Lot Premium">
      <value></value>
    </field>
    <field name="Incentives">
      <value></value>
    </field>
    <field name="Upgrades">
      <value></value>
    </field>
    <field name="Purchase Price">
      <value></value>
    </field>
    <field name="Contingent Home Location">
      <value></value>
    </field>
    <field name="chkFinancingContingency">
      <value>Off</value>
    </field>
    <field name="chkSaleContingency">
      <value>Off</value>
    </field>
    <field name="Closing Attorney">
      <value></value>
    </field>
    <field name="chkLoanTypeCash">
      <value>Off</value>
    </field>
    <field name="chkLoanTypeConvential">
      <value>Off</value>
    </field>
    <field name="chkLoanTypeFHA">
      <value>Off</value>
    </field>
    <field name="chkLoanTypeVA">
      <value>Off</value>
    </field>
    <field name="chkLoanTypeOther">
      <value>Off</value>
    </field>
    <field name="chkLoanTypeUSDA">
      <value>Off</value>
    </field>
    <field name="Checkbox">
      <value>Off</value>
    </field>
    <field name="chkAdditionalIncentive">
      <value>Off</value>
    </field>
    <field name="chkAddendumC">
      <value>Off</value>
    </field>
    <field name="SellingCompany">
      <value></value>
    </field>
    <field name="chkAddendumI">
      <value>Off</value>
    </field>
    <field name="chkAddendumF">
      <value>Off</value>
    </field>
    <field name="chkAddendumE">
      <value>Off</value>
    </field>
    <field name="chkAddendumK">
      <value>Off</value>
    </field>
    <field name="chkAddendumA">
      <value>Off</value>
    </field>
    <field name="chkApprovedLender">
      <value>Off</value>
    </field>
    <field name="ListingAgentName">
      <value></value>
    </field>
    <field name="chkAddendumG">
      <value>Off</value>
    </field>
    <field name="chkAddendumJ">
      <value>Off</value>
    </field>
    <field name="SellingAgentName">
      <value></value>
    </field>
    <field name="chkAddendumD">
      <value>Off</value>
    </field>
    <field name="chkAddendumH">
      <value>Off</value>
    </field>
    <field name="chkAddendumB">
      <value>Off</value>
    </field>
    <field name="chkSewer">
      <value>Off</value>
    </field>
    <field name="chkSeptic">
      <value>Off</value>
    </field>
    <field name="Additional Disclosure 1">
      <value></value>
    </field>
    <field name="Approved Lender Credit">
      <value></value>
    </field>
    <field name="Purchaser1Name">
      <value></value>
    </field>
    <field name="Client Email Address">
      <value></value>
    </field>
    <field name="Client Phone">
      <value></value>
    </field>
    <field name="Client Address">
      <value></value>
    </field>
    <field name="Client City State Zip">
      <value></value>
    </field>
    <field name="Purchaser2Name">
      <value></value>
    </field>
    <field name="Purchaser2 Address">
      <value></value>
    </field>
    <field name="Purchaser2 City State Zip">
      <value></value>
    </field>
    <field name="Purchaser2 Phone">
      <value></value>
    </field>
    <field name="Purchaser2 Email Address">
      <value></value>
    </field>
  </fields>
  <annots>
    <link page="3" rect="329.448,537.714,348.938,553.213" name="fe801675e198d79c-849d5688e56d7def" width="0" style="solid"/>
    <link page="3" rect="448.34,526.215,457.84,537.714" name="fe801676e198d79d-849d5687e56d7dee" width="0" style="solid"/>
    <link page="3" rect="399.697,407.225,420.857,422.724" name="fe801677e198d79e-849d5686e56d7ded" width="0" style="solid"/>
    <link page="3" rect="480.625,269.236,501.785,280.735" name="fe801678e198d79f-849d5685e56d7dec" width="0" style="solid"/>
    <link page="4" rect="84.2371,422.223,93.7371,433.722" name="fe80167be198d7a2-849d5682e56d7de9" width="0" style="solid"/>
    <link page="5" rect="418.574,483.217,428.074,498.716" name="fe80167ee198d7a5-849d567fe56d7de6" width="0" style="solid"/>
    <link page="5" rect="470.995,318.23,480.495,329.729" name="fe80167fe198d7a6-849d567ee56d7de5" width="0" style="solid"/>
    <link page="5" rect="272.505,245.236,282.005,260.735" name="fe801680e198d7a7-849d567de56d7de4" width="0" style="solid"/>
    <link page="5" rect="292.984,80.25,302.484,95.749" name="fe801681e198d7a8-849d567ce56d7de3" width="0" style="solid"/>
    <link page="6" rect="480.821,691.201,490.321,702.7" name="fe801684e198d7ab-849d5679e56d7de0" width="0" style="solid"/>
    <link page="6" rect="389.066,537.714,398.566,549.213" name="fe801685e198d7ac-849d5678e56d7ddf" width="0" style="solid"/>
    <link page="6" rect="189.209,510.716,208.699,526.215" name="fe801686e198d7ad-849d5677e56d7dde" width="0" style="solid"/>
    <link page="6" rect="256.133,510.716,270.633,526.215" name="fe801687e198d7ae-849d5676e56d7ddd" width="0" style="solid"/>
    <link page="6" rect="451.64,510.716,471.131,526.215" name="fe801688e198d7af-849d5675e56d7ddc" width="0" style="solid"/>
    <link page="7" rect="137.25,433.722,146.75,445.221" name="fe80168be198d7b2-849d5672e56d7dd9" width="0" style="solid"/>
    <link page="7" rect="358.676,287.733,378.166,299.232" name="fe80168ce198d7b3-849d5671e56d7dd8" width="0" style="solid"/>
    <link page="7" rect="428.602,287.733,449.762,299.232" name="fe80168de198d7b4-849d5670e56d7dd7" width="0" style="solid"/>
    <link page="8" rect="476.885,652.704,486.385,668.203" name="fe801690e198d7b7-849d566de56d7dd4" width="0" style="solid"/>
    <link page="8" rect="443.554,545.213,453.054,556.712" name="fe801691e198d7b8-849d566ce56d7dd3" width="0" style="solid"/>
    <link page="9" rect="382.945,652.704,407.436,664.203" name="fe801694e198d7bb-849d5669e56d7dd0" width="0" style="solid"/>
    <link page="9" rect="217.767,556.712,242.257,568.211" name="fe801695e198d7bc-849d5668e56d7dcf" width="0" style="solid"/>
    <link page="9" rect="134.802,518.215,159.292,529.714" name="fe801696e198d7bd-849d5667e56d7dce" width="0" style="solid"/>
    <link page="10" rect="295.277,92.25,320.875,103.749" name="fe801699e198d7c0-849d5664e56d7dcb" width="0" style="solid"/>
    <link page="11" rect="145.662,599.209,171.261,610.708" name="fe80169ce198d7c3-849d5661e56d7dc8" width="0" style="solid"/>
    <link page="11" rect="448.195,455.221,462.695,466.72" name="fe80169de198d7c4-849d5660e56d7dc7" width="0" style="solid"/>
    <link page="11" rect="285.07,248.238,299.57,259.737" name="fe80169ee198d7c5-849d565fe56d7dc6" width="0" style="solid"/>
    <link page="12" rect="230.83,656.704,245.43,668.203" name="fe8016a1e198d7c8-849d565ce56d7dc3" width="0" style="solid"/>
    <link page="12" rect="247.235,405.225,272.834,416.724" name="fe8016a2e198d7c9-849d565be56d7dc2" width="0" style="solid"/>
    <link page="12" rect="524.251,359.229,549.85,370.728" name="fe8016a3e198d7ca-849d565ae56d7dc1" width="0" style="solid"/>
    <link page="13" rect="250.031,618.207,264.531,633.706" name="fe8016a6e198d7cd-849d5657e56d7dbe" width="0" style="solid"/>
    <link page="13" rect="458.509,481.217,484.107,492.716" name="fe8016a7e198d7ce-849d5656e56d7dbd" width="0" style="solid"/>
    <link page="13" rect="169.745,415.722,195.344,431.221" name="fe8016a8e198d7cf-849d5655e56d7dbc" width="0" style="solid"/>
    <link page="13" rect="250.288,304.23,264.788,319.729" name="fe8016a9e198d7d0-849d5654e56d7dbb" width="0" style="solid"/>
    <link page="14" rect="324.543,341.729,350.703,353.229" name="fe8016ace198d7d3-849d5651e56d7db8" width="0" style="solid"/>
    <link page="14" rect="420.234,218.739,446.394,234.238" name="fe8016ade198d7d4-849d5650e56d7db7" width="0" style="solid"/>
    <link page="14" rect="211.09,130.246,230.58,141.745" name="fe8016aee198d7d5-849d564fe56d7db6" width="0" style="solid"/>
    <link page="14" rect="263.467,130.246,284.627,141.745" name="fe8016afe198d7d6-849d564ee56d7db5" width="0" style="solid"/>
    <link page="14" rect="345.506,130.246,371.666,141.745" name="fe8016b0e198d7d7-849d564de56d7db4" width="0" style="solid"/>
    <link page="2" rect="254.232,668.203,263.732,679.702" name="fe801669e198d790-849d5694e56d7dfb" width="0" style="solid"/>
    <link page="2" rect="365.837,629.706,389.775,645.205" name="fe80166ae198d791-849d5693e56d7dfa" width="0" style="solid"/>
    <link page="2" rect="499.056,600.708,508.556,612.207" name="fe80166be198d792-849d5692e56d7df9" width="0" style="solid"/>
    <link page="2" rect="429.119,573.71,438.619,585.209" name="fe80166ce198d793-849d5691e56d7df8" width="0" style="solid"/>
    <link page="2" rect="385.17,562.211,405.768,573.71" name="fe80166de198d794-849d5690e56d7df7" width="0" style="solid"/>
    <link page="2" rect="520.364,489.217,529.864,500.716" name="fe80166ee198d795-849d568fe56d7df6" width="0" style="solid"/>
    <link page="2" rect="261.997,473.718,282.595,489.217" name="fe80166fe198d796-849d568ee56d7df5" width="0" style="solid"/>
    <link page="2" rect="455.747,181.741,465.247,193.24" name="fe801670e198d797-849d568de56d7df4" width="0" style="solid"/>
    <link page="2" rect="145.256,143.244,154.756,154.743" name="fe801671e198d798-849d568ce56d7df3" width="0" style="solid"/>
    <link page="2" rect="458.77,81.749,468.27,93.248" name="fe801672e198d799-849d568be56d7df2" width="0" style="solid"/>
  </annots>
  <pages>
    <defmtx matrix="1,0,0,-1,0,792" />
  </pages>
</xfdf>
`;
